<script lang="ts">
  // The fitness signature after the ride, with how much each part moved.
  import type { ReportContext } from '../context'

  export let ctx: ReportContext
  export let variant: 'cards' | 'inline' = 'cards'

  $: bt = ctx.data.breakthrough
  $: sig = bt?.after ?? ctx.data.signature
  $: items = sig ? [
    { label: 'Peak Power', value: ctx.fmt.int(sig.pp), unit: 'W', delta: bt?.delta ? ctx.fmt.signed(bt.delta.pp) : null, raw: bt?.delta?.pp ?? 0, deltaUnit: 'W' },
    { label: 'High Intensity', value: ctx.fmt.fixed(sig.hie, 1), unit: 'kJ', delta: bt?.delta ? ctx.fmt.signed(bt.delta.hie, 1) : null, raw: bt?.delta?.hie ?? 0, deltaUnit: 'kJ' },
    { label: 'Threshold', value: ctx.fmt.int(sig.tp), unit: 'W', delta: bt?.delta ? ctx.fmt.signed(bt.delta.tp) : null, raw: bt?.delta?.tp ?? 0, deltaUnit: 'W' },
  ] : []
</script>

<div class="xr-deltas xr-{variant}">
  {#each items as item}
    <div class="xr-item">
      <div class="xr-label">{item.label}</div>
      <div class="xr-value">{item.value}<span class="xr-unit">{item.unit}</span></div>
      {#if item.delta}
        <div class="xr-delta" class:xr-up={item.raw > 0} class:xr-down={item.raw < 0}>
          {#if item.raw > 0}▲{:else if item.raw < 0}▼{/if} {item.delta.replace(/^[+−]/, '')} {item.deltaUnit}
        </div>
      {/if}
    </div>
  {/each}
</div>

<style>
  .xr-deltas {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
  }
  .xr-cards .xr-item {
    padding: 22px 24px 24px;
    border-radius: 24px;
    background: var(--panel);
    border: 2px solid var(--faint);
  }
  .xr-inline .xr-item + .xr-item {
    border-left: 2px solid var(--faint);
    padding-left: 24px;
  }
  .xr-label {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .xr-value {
    margin-top: 8px;
    font-family: var(--display);
    font-weight: 700;
    font-size: 72px;
    line-height: 1;
  }
  .xr-unit {
    margin-left: 6px;
    font-size: 0.45em;
    color: var(--muted);
  }
  .xr-delta {
    display: inline-block;
    margin-top: 12px;
    padding: 5px 14px;
    border-radius: 999px;
    font-size: 24px;
    font-weight: 700;
    background: var(--faint);
  }
  .xr-delta.xr-up {
    color: var(--good);
    background: color-mix(in srgb, var(--good) 16%, transparent);
  }
  .xr-delta.xr-down {
    color: var(--bad);
    background: color-mix(in srgb, var(--bad) 16%, transparent);
  }
</style>
